import Translator from 'tools/trans';
import { roundNumber } from 'tools/roundNumber';

export const shortenNumber = (number, decimalPlaces = 0) => {
    return parseFloat(number).toFixed(decimalPlaces);
};

export const numberFormat = (number, decimalPlaces, decimalSeparator, thousandSeparator) => {
    if (isNaN(number) || isNaN(parseFloat(number))) {
        return null;
    }

    if (!decimalSeparator) {
        decimalSeparator = Translator.trans('SEP_DECIMAL');
        if (decimalSeparator === 'SEP_DECIMAL') {
            decimalSeparator = '.';
        }
    }
    if (!thousandSeparator) {
        thousandSeparator = Translator.trans('SEP_THOUSAND');
        if (thousandSeparator === 'SEP_THOUSAND') {
            thousandSeparator = '.';
        }
    }
    decimalPlaces = decimalPlaces || 0;

    number = shortenNumber(number, decimalPlaces);

    const parts = number.toString().split('.');
    let wholePart = parts[0];
    const regex = /(\d+)(\d{3})/;
    while (regex.test(wholePart)) {
        wholePart = wholePart.replace(regex, `$1${ thousandSeparator }$2`);
    }

    return `${ wholePart }${ parts.length > 1 ? decimalSeparator : '' }${ parts[1] || '' }`;
};

export const parseFormattedNumber = (string, decimalPlaces = 0) => {
    if (typeof string === 'number' || string === null) {
        return string;
    }

    const decimalSeparator = Translator.trans('SEP_DECIMAL');
    const thousandSeparator = Translator.trans('SEP_THOUSAND');
    const thousandSeparatorRegex = new RegExp(`\\${ thousandSeparator }`, 'g');
    const stripped = string.replace(thousandSeparatorRegex, '').replace(decimalSeparator, '.');

    return roundNumber(parseFloat(stripped), decimalPlaces);
};
